module.exports = __webpack_public_path__ + "img/Truce_Black_Orange_Stripe.7e2aeb4b.png";